module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientForm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex flex-column mb-3"
  }, [_c('label', [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "fs-bigger bg-lighter bold",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value)
      }, _vm.inputChanged]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Country:")]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "topCodes": _vm.topCountries,
      "openDirection": "bottom",
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false,
      "customClass": 'mb-2',
      "error": !_vm.selectedCountry
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event, 'country')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Phone:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 pr-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.dial),
      expression: "customer.dial"
    }],
    staticClass: "fs-bigger bg-lighter w-100",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": "+351"
    },
    domProps: {
      "value": (_vm.customer.dial)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "dial", $event.target.value)
      }, _vm.onDialInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 pl-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.phone),
      expression: "customer.phone"
    }],
    staticClass: "fs-bigger bg-lighter w-100",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Hotel:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.accomodation),
      expression: "customer.accomodation"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.accomodation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "accomodation", $event.target.value)
      }, _vm.inputChanged]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex flex-column mt-1 mb-3"
  }, [_c('label', [_vm._v("Room:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.room),
      expression: "customer.room"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.room)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "room", $event.target.value)
      }, _vm.inputChanged]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex flex-column mt-1 mb-3"
  }, [_c('label', {
    class: {
      'color-6': !_vm.$v.customer.email.email
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "fs-bigger bg-lighter",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }, _vm.inputChanged]
    }
  }), _vm._v(" "), (!_vm.$v.customer.email.email) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [(!_vm.$v.customer.email.email) ? _c('span', [_vm._v("Invalid email")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46daf211"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/ClientForm.vue
// module id = 1729
// module chunks = 0